/* eslint-disable react/no-array-index-key */
import { Breadcrumb as BreadcrumbComponent } from 'antd'
import { useLocation } from 'react-router-dom'

const Breadcrumb = () => {
	const { pathname } = useLocation()

	return (
		<BreadcrumbComponent style={{ margin: '16px 0' }}>
			{pathname.split('/').map((path, index) => {
				return index === 0 ? (
					<BreadcrumbComponent.Item key={index}>Dashboard</BreadcrumbComponent.Item>
				) : (
					path && (
						<BreadcrumbComponent.Item key={index}>
							{path.charAt(0).toUpperCase() + path.slice(1)}
						</BreadcrumbComponent.Item>
					)
				)
			})}
		</BreadcrumbComponent>
	)
}

export default Breadcrumb
